import { API, API_GET } from "../../config"

export const GetExperience = () => {
  return (
    API_GET(API.Experience)
  )
}